import routerOptions0 from "/vercel/path0/psychiatry/node_modules/.pnpm/nuxt@3.19.0_@parcel+watcher@2.5.1_@vue+compiler-sfc@3.5.21_db0@0.3.2_eslint@8.57.1_ioredis@5._ow4hjenlguai5buvehfvazui2e/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}